import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var planBookDetailRoute = [{
  path: "details/:id",
  name: "planBookDetail",
  component: function component() {
    return import("./plan-book-detail.vue");
  }
}];